import flowRight from 'lodash/flowRight';

import { RouteItemType } from '~/core/router';
import {
  withCheckoutOpeningLayout,
  withHomeScreenRetentionLayout,
  withLiveNotificationLayout,
  withMainLayout,
  withOnboardingLayout,
  withPromoModalLayout,
  withSubModalsLayout,
} from '~/decorators/withLayout';
import lazyComponentLoader from '~/helpers/lazyComponentLoader';
import { LiveUserNotificationPlaces } from '~/services/abTests/features';

import { getHomePageTitle, HomePagePath } from './constants';

const HomePage = lazyComponentLoader(() => import('./views/HomePage'));

export const HomePageRoute: RouteItemType = {
  Component: flowRight(
    withCheckoutOpeningLayout,
    withPromoModalLayout,
    withSubModalsLayout,
    withOnboardingLayout,
    withLiveNotificationLayout(LiveUserNotificationPlaces.HOME),
    withHomeScreenRetentionLayout,
    withMainLayout,
  )(HomePage),
  path: HomePagePath,
  getTitle: getHomePageTitle,
};
